import React from 'react'
import Section from '../components/Section'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'
import DebiImg from '../assets/images/team-images/debi.jpg'
import GroupImg from '../assets/images/team-images/group.jpg'
import HannahImg from '../assets/images/team-images/hannah.jpg'
import HeidiImg from '../assets/images/team-images/heidi.jpg'
import MaciImg from '../assets/images/team-images/maci.jpg'
import MeaghanImg from '../assets/images/team-images/meaghan.jpg'
import MonicaImg from '../assets/images/team-images/monica.jpg'
import SydneyImg from '../assets/images/team-images/sydney.jpg'
import TerrellImg from '../assets/images/team-images/terrell.jpg'

function OurTeam() {
	const teamArr = [
		{
			name: 'Sydney',
			role: 'CEO + Co-Founder',
			image: SydneyImg
		},
		{
			name: 'Terrell',
			role: 'COO + Co-Founder',
			image: TerrellImg
		},
		{
			name: 'Heidi',
			role: 'Verification Specialist',
			image: HeidiImg
		},
		{
			name: 'Maci',
			role: 'Creative Director',
			image: MaciImg
		},
		{
			name: 'Meaghan',
			role: 'Regional Director',
			image: MeaghanImg
		},
		{
			name: 'Debi',
			role: 'Advisor',
			image: DebiImg
		},
		{
			name: 'Hannah',
			role: 'Advisor',
			image: HannahImg
		},
		{
			name: 'Monica',
			role: 'Advisor',
			image: MonicaImg
		}
	]
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='col-12'>
					<img
						src={GroupImg}
						alt='The Etho team members with mountainous background'
						style={{ marginBottom: '2.4rem' }}
					/>
				</div>
				<div className='col-sm-8 col-md-7'>
					<h2>Meet Our Team</h2>
					<hr />
					<p className=''>
						The Etho is an Ethical Marketplace By Women for Women
						that is technologically driven to enable our Brands to
						manage their businesses and scale them. We do more than
						just sell unique, curated products from around the
						world, we change lives. We believe we&apos;re better
						together &mdash; join the movement by shopping
						sustainably with confidence at The Etho.
					</p>
				</div>
			</Section>

			<Section id='team__section'>
				{teamArr.map((member, i) => {
					return (
						<div className='col-md-4 text-center' key={i}>
							<div className='card'>
								<img
									src={member.image}
									alt='placeholder'
									className='card-img-top'
								/>
								<div className='card-body'>
									<h3>{member.name}</h3>
									<span>&mdash; {member.role}</span>
									<ul className='card-social-links'>
										<li>
											<a
												href='/'
												target='_blank'
												rel='noopener noreferrer'>
												<FAI
													icon={[
														'fab',
														'facebook-square'
													]}
													size='lg'
													color='rgba(72, 72, 72, 0.2)'
												/>
											</a>
										</li>
										<li>
											<a
												href='/'
												target='_blank'
												rel='noopener noreferrer'>
												<FAI
													icon={[
														'fab',
														'twitter-square'
													]}
													size='lg'
													color='rgba(72, 72, 72, 0.2)'
												/>
											</a>
										</li>
										<li>
											<a
												href='/'
												target='_blank'
												rel='noopener noreferrer'>
												<FAI
													icon={['fab', 'linkedin']}
													size='lg'
													color='rgba(72, 72, 72, 0.2)'
												/>
											</a>
										</li>
										<li>
											<a
												href='/'
												target='_blank'
												rel='noopener noreferrer'>
												<FAI
													icon={['fab', 'instagram']}
													size='lg'
													color='rgba(72, 72, 72, 0.2)'
												/>
											</a>
										</li>
									</ul>
								</div>
								<div className='card-blurb'>
									<p>
										Lorem ipsum dolor sit amet consectetur
										adipisicing elit. Voluptatem rerum
										voluptate doloribus quas quibusdam nobis
										deserunt fugiat obcaecati labore.
										Voluptas optio commodi minus libero
										obcaecati harum. Repellendus ducimus
										consectetur veniam cum molestias impedit
										blanditiis dicta quos expedita.
										Molestiae, reiciendis quod?
									</p>
								</div>
							</div>
						</div>
					)
				})}
			</Section>
		</div>
	)
}

export default OurTeam
